import { connect } from 'react-redux'
import FooterView from '../components/FooterView'
import {actions} from '../modules/language'

const mapDispatchToProps = {
  ...actions
};

const mapStateToProps = (state) => ({
  language: state.i18n.locale
});

export default connect(mapStateToProps, mapDispatchToProps)(FooterView)


// WEBPACK FOOTER //
// ./src/layouts/Footer/containers/FooterContainer.js